import { required } from '@validations'

export default {
  data() {
    return {
      required
    }
  },
}
